import { render, staticRenderFns } from "./ReaderSummary.vue?vue&type=template&id=4c946097"
import script from "./ReaderSummary.vue?vue&type=script&lang=js"
export * from "./ReaderSummary.vue?vue&type=script&lang=js"
import style0 from "./ReaderSummary.vue?vue&type=style&index=0&id=4c946097&prod&lang=css"
import style1 from "./ReaderSummary.vue?vue&type=style&index=1&id=4c946097&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports